import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div style={{ maxWidth: "600px", margin: "50px auto", padding: "1rem" }}>
      <h1>Terms and Conditions</h1>
      <p>
        {/* Replace below with your actual terms text */}
        Welcome to Senu App. By using our service, you agree to these terms and conditions...
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum at...
      </p>

      <p>
        <Link to="/">Back to Home</Link>
      </p>
    </div>
  );
}
